// promo-footer — download CTA shown across the web app (incl. the player, per
// Сергей 2026-06-21): "want to share with your team? get the app". i18n'd.
//
// Hardcoded URL — org slug verified against docs/superpowers/plans/update-banner
// and update-fetcher.js (`neodisa/band-way`).

import { t } from './i18n.js';

const DOWNLOAD_URL = 'https://bandway.app';

export interface PromoFooterHandle {
  unmount: () => void;
}

export function mountPromoFooter(host: Element): PromoFooterHandle {
  host.textContent = '';
  const root = document.createElement('div');
  root.className = 'rh-promo-footer';

  const cta = document.createElement('span');
  cta.className = 'promo-footer-cta';
  cta.textContent = t('footer.shareCta');

  const link = document.createElement('a');
  link.className = 'promo-footer-link';
  link.href = DOWNLOAD_URL;
  link.target = '_blank';
  link.rel = 'noopener';
  link.textContent = t('footer.getApp');

  root.appendChild(cta);
  root.appendChild(document.createTextNode(' '));
  root.appendChild(link);
  host.appendChild(root);

  return {
    unmount: () => {
      host.textContent = '';
    },
  };
}
